// extracted by mini-css-extract-plugin
export var active = "_ew-7";
export var container = "_ew-0";
export var evenWidth = "_ew-4";
export var large = "_ew-5";
export var outlet = "_ew-8";
export var slide = "_ew-2";
export var small = "_ew-6";
export var tab = "_ew-3";
export var tabs = "_ew-1";